<template>
  <div class="about">
    <div class="ct">
      <div class="about-a">
        <div class="dangqian">
          <span>当前位置：</span>
          <a href="#/">首页</a>
          <span>＞</span>
          <a>关于我们</a>
        </div>
      </div>
    </div>

    <div class="synopsis">
      <div class="section">
        <div class="container" style="max-width: 1160px;min-height: 255px;">
          <div class="section--header">
            <h2 class="section--title">{{ companyInfo.name }}</h2>
            <p class="section--description">{{ companyInfo.introduction }}</p>
          </div>

          <!--about-container end-->
        </div>
      </div>
      <div class="diTu" v-if="companyInfo.map">
        <img :src="companyInfo.map" />
      </div>
    </div>
  </div>
</template>
<script>
import { getCompany } from "@/api/api";
export default {
  data() {
    return {
      companyInfo: {}
    };
  },
  mounted() {
    this.getCompanyInfo();
  },
  methods: {
    getCompanyInfo() {
      getCompany().then(resp => {
        if (resp) {
          this.companyInfo = resp.data.data;
          document.title = this.companyInfo.name;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.about {
  background-color: #f6f7f8;
  text-align: left;
  margin-top: 80px;

  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.about-a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 100px;
}

.dangqian {
  font-size: 16px;
}

.diTu {
  padding-bottom: 25px;
}

.diTu img {
  width: 100%;
  height: 50%;
}
</style>
